export const API_RESOURCE = {
  AUTH: '/auth',
  CONFIG: '/configs',
  CONTRIBUTOR_GROUP: '/contributorGroups',
  COST_CENTER: '/costCenters',
  CUSTOMER: '/customers',
  DELEGATION: '/delegations',
  FILE: '/files',
  GCK_CODE: '/GCKCodes',
  OFFER: '/offers',
  RULE: '/rules',
  SLA: '/slas',
  VENDOR: '/vendors',
  SYSTEM_VARIABLE: '/systemVariables',
  USER: '/users',
  OFFER_COST_BUDGET: '/offerCostBudgets',
  ANNOUNCEMENT: '/announcements',
}
